export default function Footer() {
  return (
    <footer id="footer" className="relative bg-background-100 border-t border-background-300/30">
      <div className="max-w-[1100px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-movie-2-line text-background-950 text-base"></i>
              </div>
              <span className="font-heading text-lg font-bold text-foreground-50">桃子影院</span>
            </div>
            <p className="text-sm text-foreground-500 leading-relaxed mb-4">
              桃子影院是一个专注于高清电影、高清电视剧超清在线观看的免费平台，提供蓝光画质4K影视全部全集，永久免费不缓冲秒开播放。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 rounded-lg bg-background-200 flex items-center justify-center text-foreground-400 hover:text-primary-400 hover:bg-primary-500/10 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-lg bg-background-200 flex items-center justify-center text-foreground-400 hover:text-primary-400 hover:bg-primary-500/10 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-lg bg-background-200 flex items-center justify-center text-foreground-400 hover:text-primary-400 hover:bg-primary-500/10 transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-100 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              {[
                { label: '平台介绍', href: '#about' },
                { label: '热度榜单', href: '#ranking' },
                { label: '专题合集', href: '#index' },
                { label: '常见问答', href: '#faq' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer"
                  onClick={(e) => {
                    e.preventDefault();
                    const target = document.querySelector(item.href);
                    if (target) target.scrollIntoView({ behavior: 'smooth' });
                  }}
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-100 mb-4">影视分类</h4>
            <div className="flex flex-col gap-2">
              {['高清电影', '高清电视剧', '综艺节目', '动漫番剧', '纪录片'].map((item) => (
                <a
                  key={item}
                  href="#index"
                  className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer"
                  onClick={(e) => {
                    e.preventDefault();
                    const target = document.querySelector('#index');
                    if (target) target.scrollIntoView({ behavior: 'smooth' });
                  }}
                >
                  {item}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-100 mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-500 leading-relaxed">
              桃子影院与多家影视内容平台保持合作关系，共同为观众提供优质高清影视内容。
            </p>
          </div>
        </div>

        <div className="pt-8 border-t border-background-300/30">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-600">
              &copy; 2026 桃子影院 taozicinema.com 版权所有
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-600">
              <span>本站内容仅供学习交流</span>
              <span className="hidden sm:inline">|</span>
              <span>永久免费 · 蓝光画质 · 秒开播放</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}